import Immutable from 'seamless-immutable';
import { createActions, createReducer } from 'reduxsauce';

/* Action types and creators */

export const { Types, Creators } = createActions({
  removeSelectionServices: [],
  requestFetchServices: [],
  successFetchServices: [],
  requestSelectServices: [],
  successSelectServices: [],
  reset: []
});

/* Reducer handlers */

const defaultSelection = [{
  groupServiceId: 0,
  isRequired: false,
  services: []
}];

const INITIAL_STATE = Immutable({
  groupServices: [{
    id: 0,
    name: '',
    multipleMode: false,
    isRequired: false,
    defaultServiceId: 0,
    services: [{
      id: 0,
      name: '',
    }]
  }],
  selection: defaultSelection,
  firstSelection: true,
});

const removeSelectionServices = (state = INITIAL_STATE) =>
  ({ ...state, selection: defaultSelection, firstSelection: true });

const reset = (state = INITIAL_STATE) =>
  ({ ...state, ...INITIAL_STATE });

const successFetchServices = (state = INITIAL_STATE, action) => {
  const { groupServices } = action.payload;

  if (state.firstSelection) {
    const selection = groupServices
      .filter((gs) => !gs.multipleMode)
      .map((gs) => (
        {
          groupServiceId: gs.id,
          required: gs.required,
          services: gs.services
            .filter((s) => s.id === gs.defaultServiceId)
            .map((s) => s.id)
        }
      ));

    return {
      ...state, firstSelection: false, groupServices, selection
    };
  }

  return { ...state, groupServices };
};

const successSelectServices = (state = INITIAL_STATE, action) => {
  const newOneSelection = state.selection
    .filter((gs) => gs.groupServiceId !== action.payload.groupServiceId);

  const { groupServiceId, isRequired, services } = action.payload;

  newOneSelection.push({
    groupServiceId,
    isRequired,
    services
  });

  return { ...state, selection: newOneSelection };
};

export default createReducer(INITIAL_STATE, {
  [Types.REMOVE_SELECTION_SERVICES]: removeSelectionServices,
  [Types.SUCCESS_FETCH_SERVICES]: successFetchServices,
  [Types.SUCCESS_SELECT_SERVICES]: successSelectServices,
  [Types.RESET]: reset,
});
